import React from "react";
import { PageShell } from "../components/Layout";
import { api } from "../services/api";
import { CalendarDays, ArrowRight } from "lucide-react";
import useSeo from "../hooks/useSeo";

export default function Blog() {
  const [posts, setPosts] = React.useState([]);
  useSeo({
    title: "Sunday Ground Teer Blog | Teer Tips, Guides & Updates",
    description:
      "Sunday Ground Teer Blog - tips, guides and updates on reading teer results, common numbers, dream numbers and more.",
  });

  React.useEffect(() => {
    api.blog().then(setPosts).catch(() => setPosts([]));
  }, []);

  return (
    <PageShell title="Blog" subtitle="Tips, guides & updates about Sunday Ground Teer">
      <div className="grid md:grid-cols-3 gap-5 max-w-4xl mx-auto">
        {posts.map((p) => (
          <article
            key={p.id || p.title}
            className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow flex flex-col"
          >
            <div className="h-2 bg-[#e8491d]" />
            <div className="p-5 flex flex-col flex-1">
              <div className="flex items-center gap-1.5 text-xs text-gray-400 mb-2">
                <CalendarDays className="w-3.5 h-3.5" /> {p.date}
              </div>
              <h3 className="font-black text-[#1f2733] text-lg leading-snug mb-2">{p.title}</h3>
              <p className="text-sm text-gray-500 flex-1">{p.excerpt}</p>
              <button className="mt-4 self-start text-sm font-bold text-[#e8491d] flex items-center gap-1 hover:gap-2 transition-all">
                Read more <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </article>
        ))}
        {posts.length === 0 && (
          <div className="col-span-full text-center text-gray-400 py-10">No blog posts yet.</div>
        )}
      </div>
    </PageShell>
  );
}
